import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Select,
  Form,
  Icon,
  Input,
  Row,
  Switch,
  Cascader,
  notification,
} from 'antd'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {createUser, fetchUsers} from 'appRedux/actions/Users'

const FormItem = Form.Item

class Basic extends React.Component {
  state = {
    visible: false,
    cedula: '',
    nombre: '',
    telefono: '',
    email: '',
    pass: '',
    passReal: '',
    password: '',
    accountType:'',

    validateStatus:'',

    validateCed: '',
    validateNombre: '',
    validateTel: '',
    validateEmail: '',
    validatePass: '',

    help:'',
    helpCed: '',
    helpNombre: '',
    helpTel: '',
    helpEmail: '',
    helpPass: '',

  }

  componentDidMount() {
    this.props.fetchUsers()
  }

  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  handleCancel = e => {
    this.setState({
      cedula: '',
      nombre: '',
      telefono: '',
      email: '',
      pass: '',
      password: '',
      accountType:'',
    })

    this.props.fetchUsers()
    this.setState({visible: false})

    if (this.state.cedula == '') {
      this.setState({validateCed: '', helpCed: ''})
    }
    if (this.state.nombre == '') {
      this.setState({validateNombre: '', helpNombre: ''})
    }
    if (this.state.email == '') {
      this.setState({validateEmail: '', helpEmail: ''})
    }
    if (this.state.password == '') {
      this.setState({validatePass: '', helpPass: ''})
    }
    if (this.state.telefono == '') {
      this.setState({validateTel: '', helpTel: ''})
    }
    if (this.state.accountType == '') {
      this.setState({validateTel: '', helpTel: ''})
    }
  }


  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El usuario se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al crear el usuario.',
      })
    }
  }
  onChangeAccountType = (value) => {

    
    this.setState({
      accountType:value[0]
    })
    console.log(this.state);
    
}
  onHandleClick = event => {
    event.preventDefault()
    let {cedula, nombre, telefono, email, passReal,accountType} = this.state
    if (this.state.validateStatus != 'error') {
      if (cedula && nombre && passReal && telefono && email != ''&& accountType!='') {
        this.props.createUser(this.state, () => {
          this.props.fetchUsers()
        })

        this.setState({
          cedula: '',
          nombre: '',
          telefono: '',
          email: '',
          pass: '',
          password: '',
          accountType:''
        })

        this.onNotification('success')
      } else {
        if (this.state.cedula == '') {
          this.setState({
            validateCed: 'error',
            helpCed: 'Cédula es un campo obligatorio.',
          })
        } else {
          this.setState({validateCed: '', helpCed: ''})
        }
        if (this.state.email == '') {
          this.setState({
            validateEmail: 'error',
            helpEmail: 'Correo es un campo obligatorio.',
          })
        } else {
          this.setState({validateEmail: '', helpEmail: ''})
        }
        if (this.state.telefono == '') {
          this.setState({
            validateTel: 'error',
            helpTel: 'Télefono es un campo obligatorio.',
          })
        } else {
          this.setState({validateTel: '', helpTel: ''})
        }
        if (this.state.password == '') {
          this.setState({
            validatePass: 'error',
            helpPass: 'Password es un campo obligatorio.',
          })
        } else {
          this.setState({validatePass: '', helpPass: ''})
        }
        this.onNotification(
          'error',
          'Rellene los campos obligatorios, numero es opcional.',
        )
      }
    } else {
      this.onNotification('error', 'La contraseña de validación es incorrecta.')
    }
  }

  arrayC = () => {
    let array = this.props.placeStores
    return array.map((element, index) => {
      return {value: element.id, label: decode(element.name)}
    })
  }

  render() {
    const optionsAccount = [
      {
          key: '1',
        value: '1',
        label: 'Personal',
     
      },
      {   key: '2',
        value: '2',
        label: 'Empresa',
   
      },
    ]
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          Crear usuario
        </Button>
        
        <Modal
          afterClose={() => this.props.fetchUsers()}
          okText="Crear"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Nuevo usuario">
            <form onSubmit={this.onHandleClick}>
              <Row className="padding-modal">
              <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Cédula"
                    validateStatus={this.state.validateCed}
                    help={this.state.helpCed}
                  >
                    <Input
                      required
                      placeholder="Cédula"
                      value={this.state.cedula}
                      onChange={event => {
                        this.setState({
                          cedula: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateCed: '',
                            helpCed: '',
                          })
                        } else {
                          this.setState({
                            validateCed: 'error',
                            helpCed: 'Nombre es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Nombre"
                    validateStatus={this.state.validateNombre}
                    help={this.state.helpNombre}
                  >
                    <Input
                      required
                      placeholder="Nombre"
                      value={this.state.nombre}
                      onChange={event => {
                        this.setState({
                          nombre: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateNombre: '',
                            helpNombre: '',
                          })
                        } else {
                          this.setState({
                            validateNombre: 'error',
                            helpNombre: 'Nombre es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Correo"
                    validateStatus={this.state.validateEmail}
                    help={this.state.helpEmail}
                  >
                    <Input
                      required
                      placeholder="Correo electrónico"
                      value={this.state.email}
                      onChange={event => {
                        this.setState({
                          email: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateEmail: '',
                            helpEmail: '',
                          })
                        } else {
                          this.setState({
                            validateEmail: 'error',
                            helpEmail: 'Correo es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Télefono"
                  >
                    <Input
                      required
                      placeholder="Número de télefono"
                      value={this.state.telefono}
                      onChange={event => {
                        this.setState({
                          telefono: event.target.value,
                        })
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Contraseña"
                    validateStatus={
                      this.state.validateStatus ||
                      this.state.validatePass
                    }
                    help={this.state.help || this.state.helpPass}
                  >
                    <Input
                      required
                      type="password"
                      placeholder="Contraseña"
                      value={this.state.password}
                      onChange={event => {
                        this.setState({
                          password: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validatePass: '',
                            helpPass: '',
                          })
                        } else {
                          this.setState({
                            validatePass: 'error',
                            helpPass:
                              'Password es un campo obligatorio.',
                          })
                        }

                        if (this.state.pass === event.target.value) {
                          this.setState({
                            validateStatus: '',
                            help: '',
                            passReal: event.target.value,
                          })
                        } else {
                          this.setState({
                            validateStatus: 'error',
                            help: 'Las contraseñas no coinciden',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>
                
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Validación"
                    validateStatus={this.state.validateStatus}
                    help={this.state.help}
                  >
                    <Input
                      required
                      type="password"
                      placeholder="Validar contraseña"
                      value={this.state.pass}
                      onChange={event => {
                        this.setState({
                          pass: event.target.value,
                        })
                        if (this.state.password === event.target.value) {
                          this.setState({
                            validateStatus: '',
                            help: '',
                            passReal: event.target.value,
                          })
                        } else {
                          this.setState({
                            validateStatus: 'error',
                            help: 'Las contraseñas no coinciden',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
      <FormItem
      label="Tipo de cuenta"
        labelCol={{xs: 12, sm: 12, lg: 12, md: 12}}
  
      >
        <Cascader
          
          options={optionsAccount}
          onChange={this.onChangeAccountType}
    /*      onChange={() => {
        
            this.props.updateStatusOrder(this.props.recording.id, this.order_status );
            this.onNotification('success');
          }}*/
          placeholder="Por favor selecciona"
        />
      </FormItem>
    </Col>

              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, users}) {
  return {
    placeStores,
    users,
  }
}
export default connect(
  mapStateToProps,
  {fetchUsers, createUser},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Admin/Modal.js